<template>
    <el-dialog
        :title="`${item ? '编辑' : '添加'}标签`"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
        <el-form :model="serverForm" :rules="rules" ref="serverForm" label-width="120px" >
            <el-form-item label="社区名称" prop="project">
                <el-select v-model="serverForm.project" placeholder="请选择社区" style="width: 100%;" >
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标签名称" prop="name">
                <el-input v-model="serverForm.name" placeholder="请输入标签名称"></el-input>
            </el-form-item>

            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('serverForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('serverForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {addNewJuminTag} from "@/api/weilao";
import {getXiangMuList} from "@/api/common";

export default {
    name: "addLabelDialog",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        item: {
            type: [Object, String,Boolean],
            default: ''
        }
    },
    data() {
        return {
            projectList: [],
            serverForm: {
                project: '',
                name: '',
            },
            rules: {
                project: [{required: true, message: '请选择社区', trigger: 'blur'}],
                name: [{required: true, message: '请输入标签名称', trigger: 'blur'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.getXiangMuList()
    },
    methods: {
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projectList = _data.data
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await addNewJuminTag(
                this.serverForm.project,
                this.serverForm.name,
                this.item ? this.item.id : '',

            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }
    },
    watch: {
        item(){
            if (this.item) {
                this.serverForm.project = this.item.xiangmu_id
                this.serverForm.name = this.item.name
            }else {
                this.serverForm.project = ''
                this.serverForm.name = ''
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
